module.exports = __webpack_public_path__ + "img/ModularWall5.f0368997.jpg";